import get from 'lodash/get'
import { FieldErrors } from 'react-hook-form'

interface ErrorMessages {
  requiredErrorMessage?: string
  sameRoomErrorMessage?: string
  isFourDigitsErrorMessage?: string
  isNumericErrorMessage?: string
  backendInvalidErrorMessage?: string
}

export function getErrorMessage(
  name: string,
  errors: FieldErrors,
  errorMessages?: ErrorMessages,
) {
  const fieldError = get(errors, name)

  if (!fieldError)
    return undefined

  if (fieldError?.type === 'required')
    return errorMessages?.requiredErrorMessage

  if (fieldError?.type === 'roomWithSameNameAlreadyExists')
    return errorMessages?.sameRoomErrorMessage

  if (fieldError?.type === 'isFourDigits')
    return errorMessages?.isFourDigitsErrorMessage

  if (fieldError?.type === 'isNumeric')
    return errorMessages?.isNumericErrorMessage

  if (fieldError?.type === 'backendInvalid')
    return errorMessages?.backendInvalidErrorMessage

  return undefined
}
